import { PresentationTreeResponse, TaxonomyChild } from 'app/api/tag-queries/types';

export type SignHint = 'SIGN_WITHOUT_NEGATED' | null;

const NEGATED = /negated/i;

const bareName = (id: string): string => id.replace(/^[^:]*:/, '');

export function buildNegatedPresentationIndex(tree: PresentationTreeResponse | null | undefined): Set<string> | null {
  if (!tree?.presentationTree) return null;
  const index = new Set<string>();
  const visit = (node: TaxonomyChild) => {
    if (node.preferredLabel && NEGATED.test(node.preferredLabel)) {
      index.add(node.id);
      index.add(bareName(node.id));
    }
    (node.children ?? []).forEach(visit);
  };
  for (const network of tree.presentationTree.networks ?? []) {
    for (const root of network.roots ?? []) {
      (root.children ?? []).forEach(visit);
    }
  }
  return index;
}

export function computeSignHint(args: { sign: string | null; conceptKeys: string[]; negatedIndex: Set<string> | null; isExtensionConcept: boolean }): SignHint {
  const { sign, conceptKeys, negatedIndex, isExtensionConcept } = args;
  if (isExtensionConcept || !negatedIndex) return null;
  const presentedNegated = conceptKeys.some((k) => negatedIndex.has(k));
  if (sign === '-' && !presentedNegated) return 'SIGN_WITHOUT_NEGATED';
  return null;
}
